import { useContext } from 'react';

import { Typography } from 'components/typography';
import { SidebarStateContext } from 'contexts/sidebarStateContext';
import { Maybe } from 'types/UtilityTypes';

interface CreatedQuoteMessageProps {
  createdQuoteId: Maybe<string>;
  quoteURLInTMS: Maybe<string>;
  showWithEmptyQuoteId?: boolean;
}

export const CreatedQuoteMessage = ({
  createdQuoteId,
  quoteURLInTMS,
  showWithEmptyQuoteId = false,
}: CreatedQuoteMessageProps) => {
  const {
    currentState: { openExternalUrl },
  } = useContext(SidebarStateContext);

  const isEmptyQuoteId = createdQuoteId === '';

  return createdQuoteId || (isEmptyQuoteId && showWithEmptyQuoteId) ? (
    <div className='whitespace-pre-wrap my-3 rounded py-3 text-neutral-800 px-4 bg-success-50'>
      <Typography weight='semibold' className='mb-2'>
        Quote Created 🎉
      </Typography>

      {createdQuoteId ? (
        <Typography variant='body-sm' className='mb-2'>
          <b className='text-[14px]'>Quote ID #: </b>
          {createdQuoteId}
        </Typography>
      ) : (
        <Typography variant='body-sm' className='mb-2'>
          No Quote ID was provided by the TMS to Drumkit.
        </Typography>
      )}

      {quoteURLInTMS && (
        <Typography variant='body-sm' className='mb-1'>
          <Typography
            variant='link'
            onClick={() => openExternalUrl(quoteURLInTMS)}
          >
            Access the created quote for more details
          </Typography>
        </Typography>
      )}
    </div>
  ) : null;
};
